import {
  Flex,
  RadioButtonCheckedIcon,
  RadioButtonUncheckedIcon,
  ReadonlyField,
  Text,
} from '@shared/components';

interface ReadonlyFormRadioSelectionProps {
  value: string;
  options: {
    label: string | React.ReactNode;
    value: string;
  }[];
  withOthers?: boolean;
  otherDetails?: string | null;
}

export default function ReadonlyFormRadioSelection(
  props: Readonly<ReadonlyFormRadioSelectionProps>,
) {
  const { value, options, withOthers, otherDetails } = props;

  return (
    <Flex
      sx={(theme) => ({
        flexDirection: 'column',
        gap: theme.spacing(4),
        width: '100%',
      })}
    >
      {options.map((option) => (
        <Flex key={option.value} sx={(theme) => ({ gap: theme.spacing(2) })}>
          {value === option.value ? (
            <RadioButtonCheckedIcon sx={(theme) => ({ color: theme.palette.grey[500] })} />
          ) : (
            <RadioButtonUncheckedIcon sx={(theme) => ({ color: theme.palette.grey[400] })} />
          )}
          <Text>{option.label}</Text>
        </Flex>
      ))}
      {withOthers ? (
        <Flex sx={(theme) => ({ gap: theme.spacing(2), alignItems: 'center' })}>
          {value === 'other' ? (
            <RadioButtonCheckedIcon sx={(theme) => ({ color: theme.palette.grey[500] })} />
          ) : (
            <RadioButtonUncheckedIcon sx={(theme) => ({ color: theme.palette.grey[400] })} />
          )}
          <Text sx={{ width: '110px' }}>อื่น ๆ (โปรดระบุ)</Text>
          <ReadonlyField content={otherDetails || '-'} sx={{ maxWidth: '380px' }} />
        </Flex>
      ) : null}
    </Flex>
  );
}
